import { network } from 'services/network';

import { QueryFnResponse, QueryParams } from 'api/queries/riskDensityBy.query';

export const ENDPOINT = 'api/bo/getHeatMapResources';

export const getHeatMapResources = (params: Omit<QueryParams, 'selectBy'>) => {
    return network.post<QueryFnResponse>(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
